import { UserPopups, V1APIObjectResponse } from "@bullseye/types"

import { useUserContext } from "../providers/UserAuthProvider/UserProvider"
import { useGetRequest, usePutRequest } from "./useRequest"

// TODO: These aren't enforced on the database level right now--maybe they should be? Or at least in gump?
export type PopupType = "NPS_SURVEY" | "EXPERIENCE_ATTENDANCE"

type RecordPopupSeenRequest = {
  type: PopupType
  experience_id: string
}

export const useGetUserPopups = () => {
  const { accessToken } = useUserContext()
  const { data, isLoading, error } = useGetRequest<
    V1APIObjectResponse<UserPopups[]>
  >(
    {
      path: "v1/users/me/popups",
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
    {
      enabled: true,
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnMount: false, // Don't refetch when component remounts
      refetchOnReconnect: false, // Don't refetch on network reconnect
    },
  )

  return {
    data: data?.data?.[0],
    isLoading,
    error,
  }
}

export const useExperienceAttendancePopupSeen = () => {
  const { accessToken } = useUserContext()
  const { putRequestAsync, ...rest } = usePutRequest<
    unknown,
    RecordPopupSeenRequest
  >({
    path: `v1/users/me/popups`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return {
    recordExperienceAttendancePopupSeen: async (experience_id: string) => {
      if (!experience_id) {
        return
      }
      try {
        const result = await putRequestAsync({
          body: {
            type: "EXPERIENCE_ATTENDANCE",
            experience_id,
          },
        })
        return result
      } catch (err) {
        throw err
      }
    },
    ...rest,
  }
}
